import React from "react";
import { RaisedButton, TextField, Styles } from "material-ui";
import { Navigation, Link } from "react-router";
import Helmet from "react-helmet";

import BaseOverlay from "./overlays/base.jsx";

import FacebookLogin from "./partials/facebook-login.jsx";
import EventivalLogin from "./partials/eventival-login.jsx";
import IdaLogin from "./partials/ida-login.jsx";
import SundanceLogin from "./partials/sundance-login.jsx";
import AarpLogin from "./partials/aarp-login.jsx";
import HorizontalSeparator from "./partials/horizontal-separator.jsx";
import InjectedTenantHTML from "./partials/injected-tenant-html.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

import { isApp } from "../util";

@connectToStores
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      hasTransitionedPage: false,
      fromEventival: false,
      fromIda: false,
      fromSundance: false,
      fromAARP: false,
    };

    this._login = this._login.bind(this);
    this._cannesLogin = this._cannesLogin.bind(this);
    this._eventivalLogin = this._eventivalLogin.bind(this);
    this._idaLogin = this._idaLogin.bind(this);
    this._sundanceLogin = this._sundanceLogin.bind(this);
    this._aarpLogin = this._aarpLogin.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  componentWillMount() {
    PersonActions.clearErrors();
    if (this.props.location.state && this.props.location.state.error) {
      PersonActions.loginFailed(this.props.location.state.error);
    }

    if (this.props.location.state && this.props.location.state.username) {
      this.setState({ username: this.props.location.state.username });
    }
  }

  _login() {
    if (this.context.appSettings.cannes_mode) {
      return this._cannesLogin();
    }
    PersonActions.login({
      email: this.state.username,
      password: this.state.password,
      ...this.props.location.state
    });
  }

  _facebookLogin(data) {
    PersonActions.loginWithFacebook(data.accessToken);
  }

  _eventivalLogin(token) {
    this.setState({ fromEventival: true }, () => {
      PersonActions.loginWithEventival(token);
    });
  }

  _idaLogin(token) {
    this.setState({ fromIda: true }, () => {
      PersonActions.loginWithIda(token);
    });
  }

  _sundanceLogin(token) {
    this.setState({ fromSundance: true }, () => {
      PersonActions.loginWithSundance(token);
    });
  }

  _aarpLogin(token) {
    this.setState({ fromAARP: true }, () => {
      PersonActions.loginWithAARP(token);
    });
  }

  _cannesLogin() {
    PersonActions.loginWithCannes(this.state.username, this.state.password);
  }

  componentWillReceiveProps(props) {
    // If logged in
    if (props.isLoggedIn || props.loginSuccess) {
      setTimeout(() => {
        if (
          (this.props.location.query.next === "back" ||
            (this.props.location.state &&
              this.props.location.state.backIfTargetOkay &&
              props.targetResourceSafe)) &&
          !this.state.hasTransitionedPage
        ) {
          if (
            this.state.fromEventival ||
            this.state.fromIda ||
            this.state.fromSundance ||
            this.state.fromAARP
          ) {
            // We lose state since arbitrary redirect flow, etc., so just reset to welcome.
            this.context.router.push("/welcome");
          } else {
            this.context.router.goBack();
          }
          this.setState({ hasTransitionedPage: true });
        } else if (!this.state.hasTransitionedPage) {
          this.context.router.push(
            this.props.location.query.next || "/welcome"
          );
          this.setState({ hasTransitionedPage: true });
        }
      }, 0);
    }
  }

  getStyles() {
    return {
      container: {
        fontSize: "11pt",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 20,
        marginTop: this.props.modal ? 30 : "10%",
        maxWidth: 320,
        textAlign: "center"
      },
      form: {
        textAlign: "center"
      },
      field: {
        width: "100%"
      },
      actions: {
        marginTop: 10
      },
      error: {
        color: "#FF4136"
      },
      eventiveLogo: {
        display: "inline-block"
      },
      forgot: {
        marginTop: 20
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      cannesMode = !!this.context.appSettings.cannes_mode,
      cannesStandardLogin = this.context.tenant.cannes_standard_login,
      appLockdownMode = this.context.tenant.apple_app_lockdown_mode,
      showIda = this.context.tenant.ida_login,
      showSundance =
        this.context.tenant.sundance_login &&
        !this.context.tenant.sundance_login_disable_native_site_sso,
      showAarp = this.context.tenant.use_aarp_registration_flow,
      showFacebook =
        !cannesMode &&
        !showIda &&
        !showSundance &&
        !showAarp &&
        !this.context.appSettings.facebook_login_disabled,
      showEventival =
        this.context.appSettings.enable_eventival_login &&
        !(this.context.tenant.disable_eventival_on_mobile && isApp()),
      hasPrefilledUsername = !!(
        this.props.location.state && this.props.location.state.username
      ),
      showBack = !(
        this.props.location.state && this.props.location.state.noBack
      );

    let content = (
      <div style={styles.container} className="Eventive--LoginPage">
        <Helmet title="Login" />
        {hasPrefilledUsername ? (
          <div style={{ fontSize: "14pt", fontStyle: "italic" }}>
            Welcome back
            {this.props.location.state && this.props.location.state.firstName
              ? `, ${this.props.location.state.firstName}`
              : ""}
            !
          </div>
        ) : (
          <div>
            {cannesMode ? (
              <div>
                <img
                  src="https://storage.googleapis.com/eventive-co/cannes.svg"
                  style={{
                    width: 86,
                    height: 60,
                    display: "block",
                    margin: "0 auto 5px"
                  }}
                />
                <p>
                  Please log in with your Cannes credentials to continue.
                </p>
              </div>
            ) : cannesStandardLogin ? (
              <p>
                To access the Immersive Competition Ticket Office for the first time, please
                be aware that you need to setup your own password by clicking on "Forgot Password?"
              </p>
            ) : showIda &&
              this.context.tenant.login_introduction &&
              this.context.tenant.login_introduction.__html ? (
              <InjectedTenantHTML
                content={this.context.tenant.login_introduction}
                as="p"
              />
            ) : showIda ? (
              <p>
                Please note this screening series is only available to IDA and
                AMPAS members. If you are an IDA Member, please click IDA MEMBER
                LOGIN - CLICK HERE to log into your IDA account--you will be
                redirected to Eventive afterwards. For Non-IDA Members like
                AMPAS, please log in directly through Eventive by putting your
                email and Eventive password in the fields below and click
                “LOGIN”
              </p>
            ) : showSundance ? (
              <p>Please sign in to your Festival account.</p>
            ) : showAarp ? (
              <p>Please sign in to your AARP account.</p>
            ) :this.context.tenant.login_introduction &&
              this.context.tenant.login_introduction.__html ? (
              <InjectedTenantHTML
                content={this.context.tenant.login_introduction}
                as="p"
              />
            ) : appLockdownMode ? (
              <p>To access your account, login below.</p>
            ) : (
              <p>
                Returning customer? Login below. No account? Just go back.
                You'll create an account the first time you try to buy a{" "}
                {this.context.tenant.display_pass} {this.context.tenant.display_membership 
                ? `, ${this.context.tenant.display_membership},` : null} or ticket.
              </p>
            )}
            {showFacebook ? (
              <div style={{}}>
                <FacebookLogin
                  label="Login with Facebook"
                  success={this._facebookLogin}
                  failure={PersonActions.loginFailed}
                />
              </div>
            ) : null}
            {showEventival ? (
              <div style={Object.assign({}, showFacebook && { marginTop: 10 })}>
                <EventivalLogin
                  label="Login with Eventival"
                  success={this._eventivalLogin}
                  failure={PersonActions.loginFailed}
                />
              </div>
            ) : null}
            {showIda ? (
              <div style={Object.assign({}, showFacebook && { marginTop: 10 })}>
                <IdaLogin
                  success={this._idaLogin}
                  failure={PersonActions.loginFailed}
                />
              </div>
            ) : null}
            {showSundance ? (
              <div style={Object.assign({}, showFacebook && { marginTop: 10 })}>
                <SundanceLogin
                  success={this._sundanceLogin}
                  failure={PersonActions.loginFailed}
                  label="Sign In"
                />
              </div>
            ) : null}
            {showAarp ? (
              <div style={Object.assign({}, showFacebook && { marginTop: 10 })}>
                <AarpLogin
                  success={this._aarpLogin}
                  failure={PersonActions.loginFailed}
                  label="Sign In"
                />
              </div>
            ) : null}
            {showFacebook || showEventival || showIda ? (
              <HorizontalSeparator label="or" style={{}} />
            ) : null}
          </div>
        )}
        {showIda ? (
          <div style={{ paddingTop: 10 }}>FOR NON-IDA MEMBERS</div>
        ) : null}
        {!(showSundance || showAarp) ? (
          <form style={styles.form}>
            <div>
              <TextField
                hintText="Email address"
                value={this.state.username}
                onChange={e => this.setState({ username: e.target.value })}
                style={styles.field}
                autoComplete="username email"
                disabled={this.props.loginInProgress || hasPrefilledUsername}
              />
            </div>
            <div>
              <TextField
                hintText="Password"
                disabled={this.props.loginInProgress}
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
                style={styles.field}
                onKeyDown={e => {
                  if (e.keyCode === 13) this._login();
                }}
                autoFocus={hasPrefilledUsername}
                autoComplete="password"
                type={"password"}
              />
            </div>
            {this.props.loginErrorMessage ? (
              <p style={styles.error}>{this.props.loginErrorMessage}</p>
            ) : null}
            <div style={styles.actions}>
              <RaisedButton
                label={this.props.loginInProgress ? "Logging in..." : "Login"}
                disabled={this.props.loginInProgress}
                primary={true}
                onClick={e => this._login()}
              />
              <RaisedButton
                label="Home"
                style={{ marginLeft: 12 }}
                onClick={() => this.context.router.push("/welcome")}
              />
              {showBack ? (
                <RaisedButton
                  label="Go back"
                  style={{ marginLeft: 12 }}
                  onClick={this.context.router.goBack}
                />
              ) : null}
            </div>
            {!cannesMode ? (
              <div style={styles.forgot}>
                <Link to="/forgot">Forgot password?</Link>
              </div>
            ) : null}
          </form>
        ) : null}
      </div>
    );

    if (this.props.modal) {
      return (
        <BaseOverlay
          className={this.props.className}
          onRequestClose={this.context.router.goBack}
        >
          <div>{content}</div>
        </BaseOverlay>
      );
    } else {
      return content;
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/app/components/login.jsx